// NOTE: Wire in main-product.liquid: <script src="{{ 'koala-price-analytics.js' | asset_url }}" defer></script>
// Koala Bundle Price Reframe — Analytics Hooks (GA4 / Meta Pixel / dataLayer)
// Separate file from koala-price-sync.js to avoid coupling and worker conflicts.
(function () {
  'use strict';

  var DEBUG = false;
  try {
    DEBUG = /[?&]koala_analytics_debug=1\b/.test(window.location.search);
  } catch (e) {}

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, ['[koala-analytics]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  var PROMO_ID = 'koala-bundle';
  var PROMO_NAME = 'Koala Bundle Reframe';
  var SESSION_KEY = 'koala_promo_viewed';

  function buildPayload(block) {
    var productId = (block && block.dataset && block.dataset.productId) || '';
    var rawPrice = (block && block.dataset && block.dataset.variantPrice) || '0';
    var priceNum = 0;
    try { priceNum = parseFloat(rawPrice) / 100; } catch (e) { priceNum = 0; }
    var name = '';
    try { name = document.title || ''; } catch (e) {}
    return {
      items: [{ item_id: String(productId), item_name: name, price: priceNum }],
      promotion_id: PROMO_ID,
      promotion_name: PROMO_NAME
    };
  }

  function pushEvent(name, payload) {
    log('event', name, payload);
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
    } catch (e) { log('dataLayer err', e); }
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      }
    } catch (e) { log('gtag err', e); }
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, payload);
      }
    } catch (e) { log('fbq err', e); }
  }

  function onActivate(block) {
    var payload = buildPayload(block);
    var firstView = false;
    try {
      if (!sessionStorage.getItem(SESSION_KEY)) {
        sessionStorage.setItem(SESSION_KEY, '1');
        firstView = true;
      }
    } catch (e) {}
    if (firstView) pushEvent('view_promotion', payload);
    pushEvent('select_promotion', payload);
  }

  function onDeactivate(block) {
    pushEvent('unselect_promotion', buildPayload(block));
  }

  function attachObserver(block) {
    if (!block || block.__koalaAnalyticsBound) return;
    block.__koalaAnalyticsBound = true;
    var wasActive = block.classList.contains('price--koala-active');
    try {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName !== 'class') continue;
          var isActive = block.classList.contains('price--koala-active');
          if (isActive && !wasActive) onActivate(block);
          else if (!isActive && wasActive) onDeactivate(block);
          wasActive = isActive;
        }
      });
      mo.observe(block, { attributes: true, attributeFilter: ['class'] });
      log('observer attached', block);
    } catch (e) { log('observer err', e); }
  }

  function init() {
    var blocks = document.querySelectorAll('[data-koala-price-block]');
    for (var i = 0; i < blocks.length; i++) attachObserver(blocks[i]);
    // Event delegation: click on Koala checkboxes/tiers triggers re-scan (covers dynamic blocks)
    document.addEventListener('click', function (ev) {
      try {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (t.closest('[data-koala-price-block]') || t.closest('[data-koala-checkbox]') || t.closest('[data-koala-tier]')) {
          var fresh = document.querySelectorAll('[data-koala-price-block]');
          for (var j = 0; j < fresh.length; j++) attachObserver(fresh[j]);
        }
      } catch (e) { log('click handler err', e); }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
